import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  min-height: 70px;
`;

export const Subtitle = styled.h4`
  margin: 0 0 8px;
  color: var(--color-action-default);
  font-size: 16px;
  text-align: left;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

export const Table = styled.table`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  color: var(--color-contrast-black);
`;

export const HeaderCell = styled.th`
  min-width: 0;
  padding: 10px 6px;
  border-bottom: 1px dashed var(--color-neutral-300);
  color: var(--color-neutral-500);
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const Cell = styled.td`
  min-width: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 8px 6px;
  border-bottom: 1px solid var(--color-neutral-300);
  overflow: hidden;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CheckboxCell = styled(Cell)`
  width: 48px;
  padding: 0;
  text-align: center;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;

  > button {
    flex: 0 1 200px;
    float: none;
    margin: 0;
  }

  @media (max-width: 560px) {
    > button {
      flex-basis: 100%;
      width: 100% !important;
    }
  }
`;

export const EmptyState = styled.div`
  margin: 10px 0;
  color: var(--color-contrast-black);
  text-align: left;

  p {
    margin: 0;
    padding: 10px 0;
  }
`;

export const ErrorState = styled.div`
  margin: 10px 0;
  color: var(--color-feedback-danger-600);
  font-size: 14px;
`;

export const Overlay = styled.dialog`
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: auto;
  height: auto;
  max-width: none;
  max-height: none;
  margin: 0;
  padding: 16px;
  border: 0;
  background: rgba(0, 0, 0, 0.35);
  color: inherit;
`;

export const Dialog = styled.div`
  width: min(455px, 100%);
  padding: 24px;
  border-radius: 2px;
  background: var(--color-contrast-white);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
`;

export const DialogTitle = styled.h4`
  margin: 0 0 16px;
  color: var(--color-contrast-brand);
  font-size: 18px;
`;

export const DialogMessage = styled.p`
  margin: 0 0 24px;
  color: var(--color-contrast-brand);
  font-size: 14px;
`;

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
